import {
  AddCustomerResponse,
  // CustomerCommonResponse,
  CustomerError,
  Customer,
  CustomerResponse,
  DeletedCustomer,
  CustomerType,
  DeletedCustomerType,
  Type,
  AddCustomerTypeResponse,
} from '@core/interface/customer';
import { PagePayload } from '@core/interface/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const CustomerActions = createActionGroup({
  source: 'Customer',
  events: {
    'Load Customers': props<PagePayload>(),
    'Load Customers Success': props<CustomerResponse>(),
    'Load Customers Failure': props<CustomerError>(),
    'Add Edit Customer': props<{ customer: Customer }>(),
    'Add Customer Success': props<AddCustomerResponse>(),
    'Update Customer Success': props<AddCustomerResponse>(),
    'Add Customer Failure': props<CustomerError>(),
    'Update Customer Failure': props<CustomerError>(),
    'Delete Customer': props<{ id: number }>(),
    'Delete Customer Success': props<DeletedCustomer>(),
    'Delete Customer Failure': props<CustomerError>(),
    'Load Customer Type': emptyProps(),
    'Load Customer Type Success': props<CustomerType>(),
    'Load Customer Type Failure': props<CustomerError>(),
    'Add Edit Customer Type': props<Type>(),
    'Add Edit Customer Type Success': props<AddCustomerTypeResponse>(),
    'Update Customer Type Success': props<AddCustomerTypeResponse>(),
    'Update Customer Type Failure': props<CustomerError>(),
    'Add Edit Customer Type Failure': props<CustomerError>(),
    'Delete Customer Type': props<{ id: number }>(),
    'Delete Customer Type Success': props<DeletedCustomerType>(),
    'Delete Customer Type Failure': props<CustomerError>(),
    'Reset Delete status': emptyProps(),
  },
});
